import { createSvgIcon } from '@material-ui/core/utils';

export const BuilderIcon = createSvgIcon(
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.73016 3H19.2698C20.2222 3 21 3.73024 21 4.63363V19.3664C21 20.2698 20.2222 21 19.2698 21H4.73016C3.77778 21 3 20.2698 3 19.3664V4.63363C3 3.73024 3.77778 3 4.73016 3ZM19.2698 19.9385C19.6032 19.9385 19.873 19.6826 19.873 19.3664V8.36763H4.12698V19.3664C4.12698 19.6826 4.39683 19.9385 4.73016 19.9385H19.2698ZM4.12698 7.29862H19.873V4.63363C19.873 4.31744 19.6032 4.06148 19.2698 4.06148H4.73016C4.39683 4.06148 4.12698 4.31744 4.12698 4.63363V7.29862ZM7.88888 13.9385L10.0476 14.6236V16.1593L5.91269 14.5634V13.2986L10.0476 11.6951V13.2309L7.88888 13.9385ZM13.5555 11.3036H12.492L10.3015 16.4981H11.3571L13.5555 11.3036ZM13.9682 11.7026L18.0873 13.2986V14.5634L13.9682 16.1669V14.6311L14.0555 14.6085L16.119 13.9235L13.9682 13.2309V11.7026Z"
    />
  </svg>,
  'BuilderIcon',
);
